import HeadMeta from "@/components/common/HeadMeta";
import Pagination from "@/components/sections/Pagination";
import axios from "axios";
import Link from "next/link";

import Image from "next/image";
import React, { useEffect, useState } from "react";

export async function getStaticProps() {
  let postsData = await getProps("/api/v1/posts");
  return {
    props: {
      posts: postsData.items,
      postsError: postsData.itemsError,
    },
    revalidate: 10,
  };
}

let getProps = async (url) => {
  try {
    const resItems = await fetch(`${process.env.NEXT_PUBLIC_API}${url}`);
    const items = await resItems.json();
    return {
      items,
      itemsError: false,
    };
  } catch (error) {
    console.log(error);
    return {
      items: [],
      itemsError: true,
    };
  }
};

export default function index({ posts }) {
  const [apiUrl, setApiUrl] = useState(null);
  const [paginatedPosts, setPaginatedPosts] = useState(posts.data);

  useEffect(() => {
    if (apiUrl != null) {
      axios
        .get(apiUrl)
        .then(function (response) {
          setPaginatedPosts(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [apiUrl]);

  return (
    <>
      <HeadMeta
        title="Recursos - Servicios Contables y Bookkeeping en Miami"
        description="Explora una amplia variedad de recursos sobre contabilidad, impuestos, gestión empresarial y más en el blog de Actionis Consulting para potenciar tu negocio"
        keywords="recursos contables, blog de contabilidad, gestión empresarial, impuestos, asesoría fiscal, contabilidad empresarial, artículos financieros, administración de negocios, estrategias financieras, Actionis Consulting"
      />
      <section
        style={{
          backgroundImage: "url(/icons/actonis-icon-3.png)",
          backgroundRepeat: "repeat",
          backgroundSize: 150,
          backgroundPosition: "center top",
        }}
        className="relative flex items-center justify-center px-5 py-10 "
      >
        <div
          className="absolute w-full h-full -z-0"
          style={{
            background:
              "linear-gradient(90deg, rgba(255,255,255,1) 40%, rgba(9,9,9,0) 100%)",
          }}
        ></div>
        <div className="w-full mx-auto md:max-w-5xl 2xl:max-w-screen-2xl mt-[60px] md:mt-[120px] pt-10 ">
          <div
            data-wow-duration="1s"
            className="animate__animated animate__fadeIn wow z-30 w-full md:min-w-[500px] isolate pr-3 mb-5 md:mb-0 flex  justify-center  md:items-center  "
          >
            <div className="flex flex-col items-center md:justify-end">
              <Image
                width={800}
                height={800}
                src="/icons/news-actonis.svg"
                className="object-contain w-16 md:w-24 md:mb-10 "
                alt="Logo de Actionis con un icono de noticias"
              />
              <h1 className="mb-10 uppercase md:mt-0 text-shadow-yellow text-3xl md:text-4xl lg:text-5xl font-extrabold lg:mb-0 ">
                Recursos
              </h1>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 mx-auto md:mt-10 md:gap-4 auto-rows-fr lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {paginatedPosts ? (
              paginatedPosts.map((post, index) => (
                <Link
                  data-wow-delay={(index + 2) * 0.1 + "s"}
                  key={post.id}
                  className="bg-black min-h-[200px] relative flex flex-col justify-end p-3 overflow-hidden md:py-5 animate__animated animate__fadeIn wow pt-14 mx-auto sm:max-w-none w-full sm:pt-40 md:pt-60 md:px-8 isolate rounded-2xl xl:pt-64"
                  href={`/recursos/${post.slug}`}
                >
                  <div className="absolute top-0 right-0 m-2 md:m-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentcolor"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      style={{ filter: "drop-shadow(3px 5px 2px rgb(0 0 0 / 0.7))" }}
                      stroke="currentColor"
                      className="w-6 h-6 text-white "
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
                      />
                    </svg>
                  </div>

                  <Image
                    src={post.cover}
                    width={1000}
                    height={1000}
                    alt={post.name}
                    className="absolute inset-0 object-cover w-full h-full -z-10"
                  />
                  <div className="absolute inset-0 -z-10 bg-gradient-to-t from-blue-light via-blue-light/40" />
                  <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-blue-light/20" />
                  <h2 className="text-xs text-center text-white font-bold md:leading-6 md:text-lg">
                    {post.name}
                  </h2>
                </Link>
              ))
            ) : (
              <div className="flex justify-center py-40 col-span-full">
                <div className="relative w-20 h-20 ">
                  <Image fill sizes="(max-width: 768px) 10vw, (max-width: 1200px) 10vw, 10vw" className="object-contain" src={"/icons/loader.gif"} />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <Pagination
        apiUrl={apiUrl}
        setApiUrl={setApiUrl}
        setPaginatedPosts={setPaginatedPosts}
        pages={posts.links}
      />
    </>
  );
}
